import { type ApiResponse } from '~/shared/http-client/exceptions/type'

export const EventTabs = {
  INTRODUCTION: 'introduction',
  TIMETABLE: 'timetable',
  LAYOUT: 'layout',
  CIRCLE_LIST: 'circleList',
} as const

export type EventTab = (typeof EventTabs)[keyof typeof EventTabs]

export const EventTabLabels: { [key in EventTab]: string } = {
  introduction: '행사 소개',
  timetable: '행사 시간표',
  layout: '행사 배치도',
  circleList: '참여 서클 리스트',
}

export type EventInfo = {
  id: number
  round: number
  name?: string
  status: string
  place: string
  start_date: string
  end_date: string
}

export interface EventListApiResponse extends ApiResponse {
  data: {
    eventInfo: EventInfo[]
  }
}

// 행사 정보 상단 영역
export type EventInfoMain = {
  event_id: number
  title: string
  desc: string
  image_title: string
  image_desc: string
}

export type DropdownOption = {
  value: number
  label: string
}

export interface EventInfoMainApiResponse extends ApiResponse {
  data: {
    info: EventInfoMain
  }
}

// 행사 소개
export type EventDetail = {
  event_id: number
  event_top_image: number
  event_date: string
  event_time: string
  event_application: string
  event_caution: string
  event_caution_note: string
  event_caution_etc: string
  event_top_image_info: ImageInfo
  sponsor_list: Sponsor[]
  special_zone_list: SpecialZone[]
}

export type LocationAndScheduleInfo = {
  event_time: string
  event_date: string
  event_application: string
  event_caution: string
  event_top_image_info: ImageInfo
}

export type ImageInfo = {
  id: number
  parent_table_key: string
  original_name: string
  url: string
}

export type Sponsor = {
  id: number
  event_id: number
  sponsor_type: string
  sponsor_sort: number
  sponsor_name: string
  sponsor_image: number
  sponsor_desc: string
  image_info: ImageInfo
}

export type SpecialZone = {
  id: number
  event_id: number
  zone_sort: number
  zone_name: string
  zone_desc: string
  zone_image: number
  image_info: ImageInfo
}

export interface EventInfoDetailApiResponse extends ApiResponse {
  data: {
    detail: EventDetail
  }
}

export interface EventListApiResponse extends ApiResponse {
  data: {
    eventInfo: EventInfo[]
  }
}
